/* JAQUAN CHANGE: "My build" cart (snippets/header-mini-cart*.liquid, assets/bf-cart.css).
   The theme still does adding, quantity and remove (MiniCart in assets/scripts.js) and re-renders the
   cart's content and footer after each change. This file adds, after every render:
   - "My build · N parts" in the drawer title
   - the saved Bronco row and a fit line on each part (same rules as the product page's fit check,
     using window.BFFitment from snippets/bf-fitment-core and the "pick your Bronco" popup BFGarage)
   - "or $X/mo with Affirm" for the whole cart (Affirm's own "as low as" amount)
   - one-tap Add for "Goes with your build", the "Save this build" box (Copy link; "Email it to me" asks for
     their email and sends a "Saved Build" event to Klaviyo, v249) and "Keep shopping".
   No animations. */
(function () {
  'use strict';
  if (window.bfCart) return;
  window.bfCart = true;
  /* The fit check, shared with the collection page "My build" bar (sections/main-collection-product-grid.liquid)
     so both always agree. check(fitment lists, vendor, fitment notes, saved config) -> {state, text} or null. */
  window.bfFit = {
    saved: function () {
      return saved();
    },
    name: function (config) {
      return vehicleShort(config);
    },
    check: function (lists, vendor, notes, config) {
      if (!fitment() || !config) return null;
      var el = document.createElement('div');
      el.setAttribute('data-bfc-vendor', vendor || '');
      el.setAttribute('data-bfc-notes', notes || '');
      var box = document.createElement('span');
      box.className = 'bfc-fitdata';
      Object.keys(lists || {}).forEach(function (k) {
        var v = lists[k];
        if (!Array.isArray(v)) return;
        var n = document.createElement('span');
        n.setAttribute('data-bf-key', k);
        n.setAttribute('data-bf-values', v.join('|'));
        box.appendChild(n);
      });
      el.appendChild(box);
      return fitOf(el, config);
    }
  };

  var ICONS = {"check": "<path d=\"M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z\"/>", "warn": "<path d=\"M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z\"/>", "ask": "<path d=\"M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z\"/>"};
  function icon(name) {
    var cls = { check: 'check-circle', warn: 'warning-circle', ask: 'question' }[name] || name;
    return '<svg class="bfc-i bfc-i--' + cls + '" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" focusable="false">' + ICONS[name] + '</svg>';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function cart() {
    return document.querySelector('mini-cart');
  }
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function isOpen() {
    var m = document.getElementById('HeaderMiniCart');
    return !!(m && m.getAttribute('open') === 'true');
  }

  /* ---------------- saved Bronco + fit per part ---------------- */
  var BF = null;
  function fitment() {
    BF = window.BFFitment || null;
    return BF;
  }
  function saved() {
    try {
      return fitment() ? BF.getSaved() : null;
    } catch (e) {
      return null;
    }
  }
  function vehicleShort(config) {
    try {
      var parts = BF.vehicleParts(config) || [];
      return parts.slice(0, 2).join(' ') || 'Bronco';
    } catch (e) {
      return 'Bronco';
    }
  }
  function partFitment(item) {
    var data = {};
    item.querySelectorAll('.bfc-fitdata [data-bf-key]').forEach(function (n) {
      var v = (n.getAttribute('data-bf-values') || '')
        .split('|')
        .map(function (x) {
          return x.trim();
        })
        .filter(Boolean);
      if (v.length) data[n.getAttribute('data-bf-key')] = v;
    });
    return data;
  }
  function reasonFor(m) {
    if (m.compatible.length <= 2) {
      return (
        m.compatible
          .map(function (v) {
            return BF.displayValue(m.facet, v);
          })
          .join(' or ') + ' only'
      );
    }
    return 'Not made for ' + BF.displayValue(m.facet, m.mine);
  }
  /* Same checks as fitStatus() in assets/bronco-config-memory.js. Parts with no trim / door lists
     (universal parts) get no fit line. */
  function fitOf(item, config) {
    var P = BF.PARAM_PREFIX;
    var fit = partFitment(item);
    var vendor = item.getAttribute('data-bfc-vendor') || '';
    var notes = (item.getAttribute('data-bfc-notes') || '').toLowerCase();
    var unknownAll = (vendor === 'Barricade' || vendor === 'RedRock') &&
      (notes.indexOf('raptor fitment is not confirmed') !== -1 || notes.indexOf('raptor fitment unconfirmed') !== -1);
    var unknownLate = (vendor === 'Barricade' || vendor === 'RedRock') &&
      notes.indexOf('raptor fitment for 2025–2026 is not confirmed') !== -1;
    var year = null;
    Object.keys(config).forEach(function (k) {
      if (BF.facetOf(k.slice(P.length)) === 'year') year = parseInt(config[k], 10) || null;
    });
    var bad = [];
    var core = 0;
    var raptorUnknown = false;
    Object.keys(config).forEach(function (paramKey) {
      var key = paramKey.slice(P.length);
      var compatible = fit[key];
      if (!compatible) return;
      var facet = BF.facetOf(key);
      var mine = config[paramKey];
      var ok = compatible.some(function (v) {
        return BF.valuesEqual(facet, v, mine);
      });
      if (!ok && facet === 'trim' && BF.valuesEqual('trim', mine, 'Raptor') && (unknownAll || (unknownLate && (!year || year >= 2025)))) {
        raptorUnknown = true;
        return;
      }
      if (!ok) bad.push({ facet: facet, mine: mine, compatible: compatible });
      else if (facet === 'trim' || facet === 'door') core++;
    });
    if (bad.length) return { state: 'no', text: 'Won’t fit your Bronco: ' + bad.slice(0, 2).map(reasonFor).join(' · ') };
    if (raptorUnknown) return { state: 'ask', text: 'Raptor fit not confirmed. Ask us before ordering.' };
    if (core) return { state: 'yes', text: 'Fits your ' + vehicleShort(config) };
    return null;
  }
  function renderFit() {
    var box = document.querySelector('[data-bfc]');
    if (!box) return;
    var config = saved();
    var row = box.querySelector('[data-bfc-veh]');
    var tally = { yes: 0, no: 0, ask: 0 };
    box.querySelectorAll('.bfc-item').forEach(function (item) {
      var line = item.querySelector('[data-bfc-fit]');
      if (!line) return;
      var r = config && fitment() ? fitOf(item, config) : null;
      if (r) tally[r.state]++;
      if (!r) {
        line.hidden = true;
        return;
      }
      line.className = 'bfc-item__l bfc-fit bfc-fit--' + r.state;
      /* JAQUAN CHANGE (v257): a fit is shown as a slanted tag: orange check piece + black text piece. */
      line.innerHTML = r.state === 'yes'
        ? '<span class="bfc-tag__i">' + icon('check') + '</span><span class="bfc-tag__t">' + esc(r.text) + '</span>'
        : icon(r.state === 'no' ? 'warn' : 'ask') + '<span>' + esc(r.text) + '</span>';
      line.hidden = false;
    });
    if (row) renderVehicle(row, config, tally);
  }
  /* Top line, left half: "Add your Bronco", or once a Bronco is saved, the fit check for the whole build
     ("All 3 parts fit"). Tapping it opens the garage to add or change the Bronco. */
  function plural(n) {
    return n === 1 ? '1 part' : n + ' parts';
  }
  function renderVehicle(row, config, tally) {
    if (!fitment() || !window.BFGarage) {
      row.hidden = true;
      return;
    }
    if (!config) return; /* the "Add your Bronco" markup from the cart snippet stays */
    var parts = box().querySelectorAll('.bfc-item').length;
    var name = vehicleShort(config);
    var state = 'add';
    var head = name;
    if (tally.no) {
      state = 'no';
      head = plural(tally.no) + ' won\u2019t fit';
    } else if (tally.ask) {
      state = 'no';
      head = 'Ask us about ' + plural(tally.ask);
    } else if (tally.yes) {
      state = 'yes';
      head = parts === 1 ? 'It fits' : 'All ' + parts + ' parts fit';
    }
    row.setAttribute('data-state', state);
    row.querySelectorAll('[data-bfc-veh-i]').forEach(function (i) {
      i.hidden = i.getAttribute('data-bfc-veh-i') !== state;
    });
    row.querySelector('[data-bfc-veh-text]').innerHTML =
      '<button type="button" class="bfc-half__b" data-bfc-garage aria-label="' + esc(head + ', your ' + name + '. Change your Bronco') + '">' + esc(head) + '</button>';
  }
  function box() {
    return document.querySelector('[data-bfc]');
  }

  /* ---------------- title count ---------------- */
  function renderCount() {
    var box = document.querySelector('[data-bfc]');
    var head = document.querySelector('[data-bfc-head-count]');
    if (!box || !head) return;
    var n = parseInt(box.getAttribute('data-bfc-count'), 10) || 0;
    head.textContent = n ? '· ' + n + (n === 1 ? ' part' : ' parts') : '';
  }

  /* ---------------- Affirm for the whole cart ---------------- */
  var affP = null;
  var affTries = 0;
  var affLoading = false;
  function affirmReady() {
    return window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function';
  }
  function loadAffirm() {
    if (affLoading || window.affirm || window._affirm_config) return;
    var c = cart();
    var key = c && c.getAttribute('data-bfc-affirm-key');
    if (!key) return;
    affLoading = true;
    /* Affirm's standard loader (docs.affirm.com) */
    window._affirm_config = { public_api_key: key, script: 'https://cdn1.affirm.com/js/v2/affirm.js', locale: 'en_US', country_code: 'USA' };
    (function (m, g, n, d, a, e, h, c) {
      var b = m[n] || {},
        k = document.createElement(e),
        p = document.getElementsByTagName(e)[0],
        l = function (a, b, c) {
          return function () {
            a[b]._.push([c, arguments]);
          };
        };
      b[d] = l(b, d, 'set');
      var f = b[d];
      b[a] = {};
      b[a]._ = [];
      f._ = [];
      b._ = [];
      b[a][h] = l(b, a, h);
      b[c] = function () {
        b._.push([h, arguments]);
      };
      a = 0;
      for (c = 'set add save post open empty reset on off trigger ready setProduct'.split(' '); a < c.length; a++) f[c[a]] = l(b, d, c[a]);
      a = 0;
      for (c = ['get', 'token', 'url', 'items']; a < c.length; a++) f[c[a]] = function () {};
      k.async = !0;
      k.src = g[e];
      p.parentNode.insertBefore(k, p);
      delete g[e];
      f(g);
      m[n] = b;
    })(window, window._affirm_config, 'affirm', 'checkout', 'ui', 'script', 'ready', 'jsReady');
  }
  function readAffirm() {
    var el = document.querySelector('[data-bfc-aff]');
    if (!el || !affP) return;
    var text = (affP.textContent || '').replace(/\s+/g, ' ');
    var mo = text.match(/\$\s?([\d,]+(?:\.\d{2})?)\s*\/\s*mo/i);
    var four = text.match(/payments? of \$\s?([\d,]+(?:\.\d{2})?)/i);
    var line = mo ? 'or $' + mo[1] + '/mo with Affirm' : four ? 'or 4 payments of $' + four[1] : '';
    if (!line) {
      el.hidden = true; /* Affirm offers nothing for this total */
      return;
    }
    el.textContent = line;
    el.hidden = false;
  }
  function renderAffirm() {
    var box = document.querySelector('[data-bfc]');
    var el = document.querySelector('[data-bfc-aff]');
    if (!box || !el) return;
    var cents = parseInt(box.getAttribute('data-bfc-total'), 10) || 0;
    if (cents < 5000) {
      el.hidden = true; /* under Affirm's minimum: no line */
      return;
    }
    if (affP && affP.getAttribute('data-amount') === String(cents) && affP.textContent.trim()) {
      readAffirm();
      return;
    }
    if (!affirmReady()) {
      if (!isOpen()) return; /* Affirm loads only once someone opens the cart */
      if (affTries === 4) loadAffirm();
      if (affTries++ < 80) setTimeout(renderAffirm, 250);
      return;
    }
    if (!affP) {
      affP = document.createElement('p');
      affP.className = 'affirm-as-low-as';
      affP.setAttribute('data-page-type', 'cart');
      affP.setAttribute('aria-hidden', 'true');
      affP.style.cssText = 'position:absolute;left:-9999px;top:0;width:320px;height:1px;overflow:hidden;';
      document.body.appendChild(affP);
      new MutationObserver(readAffirm).observe(affP, { childList: true, subtree: true, characterData: true });
    }
    affP.setAttribute('data-amount', String(cents));
    try {
      window.affirm.ui.ready(function () {
        window.affirm.ui.refresh();
      });
    } catch (e) {}
  }

  /* ---------------- after every render ---------------- */
  function refresh() {
    renderCount();
    renderFit();
    renderAffirm();
  }
  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      refresh();
    }, 0);
  }

  /* ---------------- clicks ---------------- */
  function sectionsToRender(c) {
    var out = [];
    try {
      c.getSectionsToRender().forEach(function (s) {
        if (s.section && out.indexOf(s.section) === -1) out.push(s.section);
      });
    } catch (e) {}
    return out;
  }
  function addPart(btn) {
    var c = cart();
    if (!c || btn.disabled) return;
    var msg = document.querySelector('[data-bfc-add-msg]');
    btn.disabled = true;
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: parseInt(btn.getAttribute('data-bfc-add'), 10), quantity: 1 }],
        sections: sectionsToRender(c),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (res && (res.status || res.errors) && !res.items) {
          btn.disabled = false;
          if (msg) {
            msg.textContent = res.description || res.message || 'Couldn’t add that part. Try again.';
            msg.hidden = false;
          }
          return;
        }
        if (res && res.sections) c.renderContents(res);
        else if (typeof c.updateSectionContents === 'function') c.updateSectionContents();
        try {
          /* pubsub.js globals: lets the collection build bar update too */
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bf-cart', cartData: res });
          }
        } catch (e) {}
      })
      .catch(function () {
        btn.disabled = false;
        if (msg) {
          msg.textContent = 'Couldn’t add that part. Try again.';
          msg.hidden = false;
        }
      });
  }
  function copyLink(btn) {
    var url = btn.getAttribute('data-bfc-share');
    var label = btn.querySelector('[data-bfc-share-text]');
    // JAQUAN CHANGE (v248): the button's own words come back after "Link copied".
    var was = label ? label.getAttribute('data-was') || label.textContent : '';
    if (label) label.setAttribute('data-was', was);
    function done(ok) {
      if (!label) return;
      label.textContent = ok ? 'Link copied \u2713' : 'Copy this link: ' + url;
      btn.classList.toggle('is-copied', ok);
      setTimeout(function () {
        label.textContent = was;
        btn.classList.remove('is-copied');
      }, ok ? 2500 : 8000);
    }
    if (navigator.share && window.matchMedia && window.matchMedia('(pointer: coarse)').matches) {
      navigator.share({ title: 'My Bronco build', url: url }).catch(function () {});
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(
        function () {
          done(true);
        },
        function () {
          done(false);
        }
      );
    } else {
      done(false);
    }
  }

  /* ---------------- JAQUAN CHANGE (v249): "Email it to me" ----------------
     A small window asks for their email (filled in if they gave it before, same memory as
     "Save this part"), then sends a "Saved Build" event to Klaviyo with every part, the total
     and the link that refills the cart. That event starts the Saved Build emails. */
  var EMAIL_KEY = 'bf_save_email';
  function savedEmail() {
    try {
      return JSON.parse(localStorage.getItem(EMAIL_KEY) || 'null') || '';
    } catch (e) {
      return '';
    }
  }
  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }
  function buildData(box) {
    var tag = box && box.querySelector('[data-bfc-build]');
    try {
      return tag ? JSON.parse(tag.textContent) : null;
    } catch (e) {
      return null;
    }
  }
  function broncoName() {
    var BF = window.BFFitment;
    var s = BF && BF.getSaved && BF.getSaved();
    if (!s) return '';
    var parts = BF.vehicleParts(s);
    return parts.slice(0, 2).join(' ');
  }
  function sendBuild(build, email) {
    var props = {
      Items: build.items,
      Total: build.total,
      PartCount: build.count,
      BuildURL: build.url,
      Bronco: broncoName(),
      $event_id: 'build-' + Date.now()
    };
    function direct() {
      return fetch('https://a.klaviyo.com/client/events/?company_id=UbzPDG', {
        method: 'POST',
        headers: { accept: 'application/vnd.api+json', 'content-type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties: props,
              value: build.value,
              unique_id: props.$event_id,
              metric: { data: { type: 'metric', attributes: { name: 'Saved Build' } } },
              profile: { data: { type: 'profile', attributes: { email: email } } }
            }
          }
        })
      }).then(function (res) {
        if (!res.ok) throw new Error('Klaviyo ' + res.status);
      });
    }
    // Klaviyo's own site script first (so it lands on the right profile), then the direct endpoint.
    var k = window.klaviyo;
    if (!k || typeof k.identify !== 'function' || typeof k.track !== 'function') return direct();
    var go = Promise.resolve(k.identify({ email: email }))
      .then(function () {
        return k.track('Saved Build', Object.assign({}, props, { $value: build.value }));
      })
      .then(function (ok) {
        if (ok === false) throw new Error('track failed');
      });
    var timeout = new Promise(function (resolve, reject) {
      setTimeout(function () {
        reject(new Error('timeout'));
      }, 6000);
    });
    return Promise.race([go, timeout]).catch(direct);
  }
  var toastEl = null;
  function toast(text) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'bf-savetoast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = text;
    toastEl.hidden = false;
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () {
      toastEl.hidden = true;
    }, 4000);
  }
  var emailDlg = null;
  var emailFor = null;
  function openEmail(btn) {
    var box = btn.closest('.bfc-save');
    var build = buildData(box);
    if (!build || !build.items || !build.items.length) return;
    if (!emailDlg) {
      emailDlg = document.createElement('dialog');
      emailDlg.className = 'bf-savedlg bfc-emaildlg';
      emailDlg.setAttribute('aria-labelledby', 'BfcEmailTitle');
      emailDlg.innerHTML =
        '<form class="bf-savedlg__panel" method="dialog" novalidate>' +
        '<button type="button" class="bf-savedlg__close" data-bfc-dlg-close aria-label="Close">' +
        '<svg width="20" height="20" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" focusable="false"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"/></svg></button>' +
        '<p class="bf-savedlg__title" id="BfcEmailTitle">Save this build</p>' +
        '<p class="bf-savedlg__part" data-bfc-dlg-sum></p>' +
        '<div class="bfc-emaildlg__pics" data-bfc-dlg-pics aria-hidden="true"></div>' +
        '<label class="bf-savedlg__label" for="BfcEmailInput">Your email</label>' +
        '<input class="bf-savedlg__input" id="BfcEmailInput" type="email" autocomplete="email" inputmode="email" placeholder="you@example.com" required>' +
        '<button type="submit" class="bf-savedlg__btn">Email me this build</button>' +
        '<p class="bf-savedlg__note">We’ll email you this build with a link that puts these parts back in your cart, plus 2 reminders. No spam.</p>' +
        '<p class="bf-savedlg__msg" role="status" aria-live="polite" data-bfc-dlg-msg></p>' +
        '</form>';
      document.body.appendChild(emailDlg);
      var form = emailDlg.querySelector('form');
      var input = emailDlg.querySelector('input');
      var submit = emailDlg.querySelector('.bf-savedlg__btn');
      var msg = emailDlg.querySelector('[data-bfc-dlg-msg]');
      emailDlg.addEventListener('click', function (e) {
        if (e.target === emailDlg || e.target.closest('[data-bfc-dlg-close]')) emailDlg.close();
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var job = emailFor;
        if (!job) return;
        var email = input.value.trim();
        if (!validEmail(email)) {
          msg.textContent = 'Please enter a valid email.';
          input.focus();
          return;
        }
        submit.disabled = true;
        msg.textContent = '';
        sendBuild(job.build, email)
          .then(function () {
            try {
              localStorage.setItem(EMAIL_KEY, JSON.stringify(email));
            } catch (err) {}
            emailDlg.close();
            var label = job.btn.querySelector('[data-bfc-email-text]');
            if (label) label.textContent = 'Emailed ✓';
            job.btn.classList.add('is-copied');
            var sent = job.box.querySelector('[data-bfc-sent]');
            if (sent) {
              sent.textContent = 'Sent to ' + email;
              sent.hidden = false;
            }
            toast('Sent. Check your email.');
          })
          .catch(function () {
            msg.textContent = 'That didn’t go through. Please try again.';
          })
          .then(function () {
            submit.disabled = false;
          });
      });
    }
    emailFor = { btn: btn, box: box, build: build };
    emailDlg.querySelector('[data-bfc-dlg-sum]').textContent =
      build.count + (build.count === 1 ? ' part' : ' parts') + ' · ' + build.total;
    var pics = emailDlg.querySelector('[data-bfc-dlg-pics]');
    pics.replaceChildren();
    build.items.slice(0, 5).forEach(function (it) {
      if (!it.ImageURL) return;
      var img = document.createElement('img');
      img.src = it.ImageURL;
      img.alt = '';
      img.width = 44;
      img.height = 44;
      pics.appendChild(img);
    });
    emailDlg.querySelector('[data-bfc-dlg-msg]').textContent = '';
    emailDlg.querySelector('input').value = savedEmail();
    if (typeof emailDlg.showModal === 'function') emailDlg.showModal();
    else emailDlg.setAttribute('open', '');
    emailDlg.querySelector('input').focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var add = t.closest('[data-bfc-add]');
    if (add && add.tagName === 'BUTTON') {
      e.preventDefault();
      addPart(add);
      return;
    }
    var share = t.closest('[data-bfc-share]');
    if (share) {
      e.preventDefault();
      copyLink(share);
      return;
    }
    var mail = t.closest('[data-bfc-email]');
    if (mail) {
      e.preventDefault();
      openEmail(mail);
      return;
    }
    if (t.closest('[data-bfc-close]')) {
      e.preventDefault();
      var c = cart();
      if (c && c.close) c.close();
      return;
    }
    if (t.closest('[data-bfc-garage]')) {
      e.preventDefault();
      var c2 = cart();
      if (c2 && c2.close) c2.close();
      if (window.BFGarage && window.BFGarage.open) window.BFGarage.open();
    }
  });

  /* ---------------- wiring ---------------- */
  function start() {
    var content = document.getElementById('header-mini-cart-content');
    var foot = document.getElementById('header-mini-cart-footer');
    if (content) new MutationObserver(queue).observe(content, { childList: true });
    if (foot) new MutationObserver(queue).observe(foot, { childList: true });
    document.addEventListener('mini-cart:opened', function () {
      affTries = 0;
      queue();
    });
    window.addEventListener('bf:vehicle-change', queue);
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
